import { render, staticRenderFns } from "./ParcelsMessagesList.vue?vue&type=template&id=331e0610&scoped=true&"
import script from "./ParcelsMessagesList.vue?vue&type=script&lang=js&"
export * from "./ParcelsMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsMessagesList.vue?vue&type=style&index=0&id=331e0610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e0610",
  null
  
)

export default component.exports